"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.revenueAdjustmentNameMap = exports.AdjustmentType = void 0;
var AdjustmentType;
(function (AdjustmentType) {
    AdjustmentType["BONUS"] = "bonus";
    AdjustmentType["COLLECTIONS_LATE_FEE"] = "collections_late_fee";
    AdjustmentType["CREDIT_ADJUSTMENT"] = "credit_adjustment";
    AdjustmentType["CREDIT_TRANSFER"] = "credit_transfer";
    AdjustmentType["HOURLY_FACILITY_INITIATED_ADJUSTMENT"] = "hourly_facility_initiated_adjustment";
    AdjustmentType["HOURLY_PRO_INITIATED_ADJUSTMENT"] = "hourly_pro_initiated_adjustment";
    AdjustmentType["HOURLY_OTHER"] = "hourly";
    AdjustmentType["INVOICING_FEE"] = "invoicing_fee";
    AdjustmentType["PROCESSING_FEE"] = "processing_fee";
    AdjustmentType["PARKING_REIMBURSEMENT"] = "parking_reimbursement";
    AdjustmentType["ORIENTATION"] = "orientation";
    AdjustmentType["OPT_OUT"] = "opt_out";
    AdjustmentType["VMS_FEE"] = "vms_fee";
    AdjustmentType["REBATE_PROMO_CREDIT"] = "rebate_promo_credit";
    AdjustmentType["REBATE_FOUR_HOUR_MINIMUM"] = "rebate_4hour_minimum";
    AdjustmentType["REBATE_LATE_CANCELLATION"] = "rebate_late_cancellation";
    AdjustmentType["REBATE_BETTER_PRO_EXPERIENCE"] = "rebate_better_pro_experience";
    AdjustmentType["REBATE_OTHER"] = "rebate";
    AdjustmentType["EDUCATION_STIPEND"] = "education_stipend";
    AdjustmentType["SHORT_PAY"] = "short_pay";
    AdjustmentType["CANCELLATION_FEE"] = "cancellation_fee";
    AdjustmentType["EARLY_PAYMENT_DISCOUNT"] = "early_payment_discount";
    AdjustmentType["OTHER_FEES"] = "other_fees";
    AdjustmentType["WRITE_OFF_RECOVERY"] = "wo_recovery";
    AdjustmentType["MEAL_PENALTY_FEE"] = "meal_penalty_fee";
    AdjustmentType["SCHEDULING_ASSURANCE"] = "scheduling_assurance";
    AdjustmentType["TRUST_AND_SAFETY_FEE_CREDIT"] = "trust_and_safety_fee_credit";
})(AdjustmentType || (exports.AdjustmentType = AdjustmentType = {}));
exports.revenueAdjustmentNameMap = new Map([
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.VMS_FEE}`,
        'VMS fee',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.REBATE_PROMO_CREDIT}`,
        'Rebate promo credit',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.REBATE_FOUR_HOUR_MINIMUM}`,
        'Rebate - Scheduling Assurance',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.REBATE_LATE_CANCELLATION}`,
        'Late cancellation credit',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.REBATE_BETTER_PRO_EXPERIENCE}`,
        'Rebate better pro experience',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.HOURLY_PRO_INITIATED_ADJUSTMENT}`,
        'Hourly pro initiated adjustment',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.HOURLY_FACILITY_INITIATED_ADJUSTMENT}`,
        'Hourly facility initiated adjustment',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.WRITE_OFF_RECOVERY}`,
        'Write-off recovery',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.MEAL_PENALTY_FEE}`,
        'Meal Penalty',
    ],
    [
        `RevenueAdjustment.adjustment_type.${AdjustmentType.TRUST_AND_SAFETY_FEE_CREDIT}`,
        'Trust & Safety Fee Credit',
    ]
]);
